<template>
  <v-slider
    class="reset-slider"
    :value="value"
    @input="emitInput"
    @change="$emit('change', $event)"
    always-dirty
    track-color="#7f7f7f"
    :color="color"
    :min="min"
    :max="max"
    :step="step">
    <template slot="prepend">
      <span class="slider-label">{{name}}</span>
    </template>
    <template slot="append">
      <circle-image-button
        size="xSmall"
        title="Reset to Default"
        @click="reset"
        btnClass="primary"
        :image="coloredAssetUrls.reset"/>
    </template>
  </v-slider>
</template>

<script>
import circleImageButton from "./CircleImageButton";
import { limit } from "../../helpers/utils";

export default {
  name: "resetSlider",
  components: { circleImageButton },
  props: {
    value: Number,
    name: String,
    min: { type: Number, default: -100 },
    max: { type: Number, default: 100 },
    step: { type: Number, default: 10 },
    defaultValue: { type: Number, default: 0 },
    limit: Boolean,
    color: String
  },
  methods: {
    reset() { 
      this.$emit("input", this.defaultValue); 
    },
    emitInput(e){
      if (this.limit){
        this.limitEmitInput(e);
      } else {
        this.doEmitInput(e);
      }
      this.$emit("input", e);
    },
    doEmitInput(e){
      this.$emit("input", e);
    },
    limitEmitInput(e) {
      limit(this.doEmitInput.bind(this, e), 30);
    }
  },
  mounted(){
    if (this.limit){
      this.limitEmitInput = limit(this.doEmitInput.bind(this), 30);
    }
  }
};
</script>
